<template>
  <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50" @click.self="$emit('close')">
    <div class="bg-white rounded-md shadow-lg p-5 w-[30rem]">
      <h3 class="text-base font-semibold mb-3">
        Reject {{ count }} expense<span v-if="count !== 1">s</span>
      </h3>
      <p class="text-xs text-gray-600 mb-3">
        The reason below will be applied to every selected record. Each submitter will see it
        on their own copy of the expense when it returns to them for revision.
      </p>

      <label class="block text-sm font-semibold mb-1">Rejection reason (required)</label>
      <textarea
        v-model="reason"
        rows="4"
        class="w-full p-2 border border-gray-400 rounded-md text-sm"
        placeholder="Explain what needs to change so the submitter can fix it."
      ></textarea>

      <div v-if="error" class="mt-2 text-sm text-red-700">{{ error }}</div>

      <div class="flex justify-end gap-2 mt-4">
        <button
          class="text-sm px-3 py-1.5 border border-gray-400 rounded hover:bg-gray-100"
          @click="$emit('close')"
        >Cancel</button>
        <button
          class="text-sm px-3 py-1.5 rounded bg-red-600 text-white hover:bg-red-700 disabled:opacity-50"
          :disabled="!reason.trim() || submitting"
          @click="submit"
        >{{ submitting ? 'Rejecting...' : `Reject ${count}` }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default { name: "bulk-reject-modal" };
</script>

<script setup>
import { ref, defineProps, defineEmits } from "vue";

const props = defineProps({
  count: { type: Number, required: true },
  submitting: { type: Boolean, default: false },
  error: { type: String, default: "" },
});

const emit = defineEmits(["close", "confirm"]);

const reason = ref("");

function submit() {
  if (!reason.value.trim()) return;
  emit("confirm", reason.value.trim());
}
</script>
